import React, { useContext } from "react";
import { IndustryPartsTable } from "../../organisms/IndustryPartsTable";


export const IndustryPartsTemplate = () => {
  return (
    <IndustryPartsTable />
  );
}


